import React from 'react'
import Svg, { G, Rect, Text as SvgText } from 'react-native-svg'

import useTheme from '@common/hooks/useTheme'

const AmbireDevice: React.FC<any> = (props) => {
  const { theme } = useTheme()
  return (
    <Svg width="144" height="94" viewBox="0 0 122 79.557" {...props}>
      <G id="laptop_light" data-name="laptop light" transform="translate(0 -0.444)">
        <Rect
          width="122"
          height="6"
          rx="3"
          transform="translate(0 74.001)"
          fill={theme.iconPrimary}
        />
        <G
          transform="translate(10 4.444)"
          fill={theme.secondaryBackground}
          stroke={theme.iconPrimary}
          strokeWidth="4"
        >
          <Rect width="101.111" height="61.111" rx="2" stroke="none" />
          <Rect x="-2" y="-2" width="105.111" height="65.111" rx="4" fill="none" />
        </G>
        <SvgText
          x="61"
          y="40"
          textAnchor="middle"
          fontSize="20"
          fontWeight="900"
          fill="#54597a"
          fontFamily="System"
        >
          ZKX
        </SvgText>
      </G>
    </Svg>
  )
}

export default React.memo(AmbireDevice)
